var map = {
	"./focus--corporate-social-responsibility.pdf": "JqJL",
	"./focus--customer-satisfaction.pdf": "88Hs",
	"./focus--environment.pdf": "EHZC",
	"./focus--innovation.pdf": "Ott5",
	"./focus--low-carbon.pdf": "j2Z1",
	"./focus--network-reliability.pdf": "+BVx",
	"./focus--safety.pdf": "ISpd",
	"./focus--stakeholder-engagement.pdf": "+5k+",
	"./focus--value-for-money.pdf": "gmUy",
	"./pages--board-directors.pdf": "3OHP",
	"./pages--executive-management-team.pdf": "/mae",
	"./pages--resilience.pdf": "I7L0",
	"./pages--transparency.pdf": "0ShS",
	"./sections--ceo-introduction.pdf": "3kDD",
	"./sections--financial-performance.pdf": "n3kk",
	"./sections--focus-areas.pdf": "dbVN",
	"./sections--future-energy.pdf": "3tBJ",
	"./sections--governance.pdf": "ct/t",
	"./sections--operations.pdf": "8YbQ",
	"./sections--people.pdf": "ugOV",
	"./sections--uk-power-network-services.pdf": "ejVh",
	"./sections--vision-values.pdf": "7AqK",
	"./ukpn-annual-review-2018.pdf": "je7w"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "wGDx";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs ^\.\/.*\.pdf$
// module id = wGDx
// module chunks = 10